var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOthersSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.39 850.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M214.52,496.33c20.13,0,36.9-7.18,51-20.9c14.09-13.72,21.47-30.7,21.47-49.64 c0-39.19-32.21-71.19-72.47-71.19s-72.47,32-72.47,71.19c0,18.94,7.38,35.92,21.47,49.64C177.61,489.14,195.06,496.33,214.52,496.33 z M425.52,496.33c20.13,0,36.9-7.18,51-20.9c14.09-13.72,21.47-30.7,21.47-49.64c0-39.19-32.21-71.19-72.47-71.19 s-72.47,32-72.47,71.19c0,18.94,7.38,35.92,21.47,49.64C388.61,489.14,406.06,496.33,425.52,496.33z M636.51,496.33 c20.13,0,36.9-7.18,51-20.9c14.09-13.72,21.47-30.7,21.47-49.64c0-39.19-32.21-71.19-72.47-71.19s-72.47,32-72.47,71.19 c0,18.94,7.38,35.92,21.47,49.64C599.61,489.14,617.05,496.33,636.51,496.33z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersSign);
export default __webpack_public_path__ + "static/media/OthersSign.370c4f7d.svg";
export { ForwardRef as ReactComponent };